module.exports = __webpack_public_path__ + "static/media/private.fdf4d8c8.svg";